import Cookies from "js-cookie";
import { decodeAuth } from "utils/Helper";

export const matches_config = {
    body: true,
    moung: true,
    half_time: true,
    even: true,
    odd: true,
    _1x2: true,
    correct_scores: true,
}

export const report_noti_roles = ['admin', 'super'];

export const onlyFootballAcceptUsercodes = ['SZ'];

/** Read SZ usercode gating from the live session cookie (must not be frozen at first module import). */
export function isStartWithUsercode() {
    const getLocalAuth = Cookies.get("vb\C#^*gW589");
    const dcode = getLocalAuth ? decodeAuth(getLocalAuth) : null;
    return onlyFootballAcceptUsercodes.some(uc => dcode?.user?.usercode?.startsWith(uc));
}
